import { translate } from '@comparacar/lib/src/translations'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Link from '@mui/material/Link'
import NextLink from 'next/link'
import React from 'react'

const AlertComparaCarCrm: React.FC = () => {
  return (
    <Alert severity="info">
      <AlertTitle>
        {translate('AlertComparaCarCrm.title', {
          link: (
            <NextLink href="/assinar/lead?origin=CRMBonus" passHref legacyBehavior>
              <Link>{translate('AlertComparaCarCrm.link')}</Link>
            </NextLink>
          )
        })}
      </AlertTitle>
      {translate('AlertComparaCarCrm.message')}
    </Alert>
  )
}
export default AlertComparaCarCrm
